import {
  Response,
  GeneralLedgerTransaction,
  AccountBalance,
  AccountType,
  apiAbortController,
} from '@ui/src';
import api from '../../../api/api';
import { Balance } from '../../../types/account';

export const restatementTransactionsListApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRestatementTransactionsList: build.query<
      Response<GeneralLedgerTransaction>,
      string
    >({
      query: (query) => ({
        url: `/v1/general-ledger/transactions${query}&includeRemoved=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRestatementAccountBalanceById: build.query<
      Response<AccountBalance>,
      {
        id: string;
        query?: string;
        typeAcc: AccountType.CREDIT | AccountType.DEBIT;
      }
    >({
      query: (data) => ({
        url: `/v1/accounts/${data.id}/balances?all=true${data.query || ''}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRestatementTransactionsById: build.query<
      { data: GeneralLedgerTransaction },
      string
    >({
      query: (id) => ({
        url: `/v1/general-ledger/transactions/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAllRestatementDebitAccountBalances: build.query<
      Response<Balance>,
      { id: string }
    >({
      query: (data) => ({
        url: `/v1/accounts/${data.id}/balances?all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAllRestatementCreditAccountBalances: build.query<
      Response<Balance>,
      { id: string }
    >({
      query: (data) => ({
        url: `/v1/accounts/${data.id}/balances?all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetRestatementTransactionsByIdQuery,
  useLazyGetRestatementTransactionsListQuery,
} = restatementTransactionsListApi;

export const {
  endpoints: { getRestatementTransactionsById, getRestatementTransactionsList },
} = restatementTransactionsListApi;
